<template>
  <data-table-consulta-comp
    :colNames="colNames"
    :colWidth="colWidth"
    :eventBusDataName="eventBusDataName"
    :eventBusDataPaginationName="eventBusPaginationName">
    <template v-slot="slotProps">
      <td>
        <div class="align-content-center">
          <div class="text-center">
            <select class="custom-select m-1 w-75" v-model="motivosSelecionado[slotProps.itemData.processo]" @change="() => changeMotivo(slotProps)">
              <option v-for="(item, indice) in motivos" :key="indice"
                :value="item.id">{{ item.descricaoMotivo }}</option>
            </select>
          </div>
        </div>
      </td>
      <td>
        <div class="align-content-center text-center">
          <i
            v-tooltip.auto-start="`Remover Processo ${slotProps.itemData.processo}`"
            class="fa fa-trash-o fa-1-5x text-danger m-1 link"
            aria-hidden="true"
            @click.prevent="removerProcesso(slotProps.itemData.processo)"
          ></i>
        </div>
      </td>
    </template>
  </data-table-consulta-comp>
</template>

<script>
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'

import DadosFixosService from '@/services/DadosFixosService'

import DataValues from '@/components/data-table-consulta/DataValues'
import eventBus from '@/uteis/eventBus'

export default {
  components: {
    dataTableConsultaComp
  },

  props: {
    processos: { type: Array, required: true },
    destinatarios: { type: Object, required: true },
    eventRemoverProcesso: { type: String, required: true }
  },

  data () {
    return {
      motivos: [],
      motivosSelecionado: {},
      colNames: ['Número Protocolo', 'Motivo da Tramitação', 'Ações'],
      dataTableColumn: [{
        column: 'processo',
        converter: 'protocolo'
      }],
      colWidth: [20, 70, 10],
      eventBusDataName: 'formularioProcesso',
      eventBusPaginationName: 'formularioProcessoDataPagination',
      eventBusAutoComplete: 'autoCompleteValeuSelected',
      urlDestinatariosEstruturas: '/d0593/pae-back/v1/dadosFixos/motivo',
      formulario: {},
      motivoProcesso: null,
      mutation: 'MUT_MOTIVOS_PROCESSO',
      mutationClean: 'MUT_DEFAULT_MOTIVOS_PROCESSO'
    }
  },

  methods: {
    sleep (ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },
    async getMotivos () {
      await this.sleep(300)
      this.service.buscarMotivos().then(response => {
        const defaultMotivo = [{
          codigoMotivo: -1,
          dataCriacao: 100000000000,
          descricaoMotivo: 'SELECIONE UM MOTIVO',
          id: -1,
          situacao: 'ATIVO'
        }]
        this.motivos = defaultMotivo.concat(response.data)
        var motivosSelecionado = this.motivosSelecionado
        var destinatarios = this.destinatarios
        for (var index in motivosSelecionado) {
          this.motivosSelecionado[index] = destinatarios[index] ? destinatarios[index].idMotivoTramite : -1
        }
        this.initMotivoSelecionado()
      })
    },

    initMotivoSelecionado () {
      for (var index in this.processos) {
        var value = this.processos[index]
        this.changeMotivo({
          itemData: value
        })
      }
    },

    changeMotivo (slotProps) {
      var id = this.motivosSelecionado[slotProps.itemData.processo]
      var motivo = this.getMotivo(id)
      var data = {
        ...slotProps,
        data: motivo
      }
      this.changeMotivosProcesso(data)
    },

    getMotivo (id) {
      for (var index in this.motivos) {
        var motivo = this.motivos[index]
        if (motivo.id === id) {
          return motivo
        }
      }
    },

    changeMotivosProcesso (data) {
      this.$store.commit(this.mutation, data)
    },

    popularPaginacao (numeroPagina = 1) {
      var rowsNumber = 10
      var data = this.processos

      var destinatarios = this.destinatarios
      for (var index in destinatarios) {
        var destinatario = destinatarios[index]
        this.motivosSelecionado[destinatario.processo] = destinatario.idMotivoTramite
      }

      var dataValues = new DataValues(data, numeroPagina, rowsNumber)
      dataValues.dataTableColumn = this.dataTableColumn

      eventBus.$emit(this.eventBusDataName, dataValues)
    },

    removerProcesso (processo) {
      delete this.motivosSelecionado[processo]
      eventBus.$emit(this.eventRemoverProcesso, processo)
    }
  },

  mounted () {
    this.popularPaginacao()
  },

  created () {
    this.service = new DadosFixosService()

    for (var index in this.processos) {
      var value = this.processos[index]

      this.motivosSelecionado[value.processo] = ''
    }

    this.getMotivos()

    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.popularPaginacao(numeroPagina)
    })
  },

  watch: {
    destinatarios (newValue, oldValue) {
      console.log(newValue, oldValue)
    },

    async processos () {
      this.$store.commit(this.mutationClean)
      this.popularPaginacao()
      this.initMotivoSelecionado()
    }
  },

  destroyed () {
    this.$store.commit(this.mutationClean)
  }
}
</script>

<style scoped>

</style>
